<template>
    <b-modal
        :title="$t(id ? 'edit_collection' : 'create_collection')"
        :visible="value"
        @close="$emit('input', false)"
        @shown="loadCollectionEditor"
        :id="'modal-edit-collection-' + id"
        size="lg"
        no-close-on-backdrop
        :ok-title="$t('save')"
        @ok="save"
        :ok-disabled="saving"
        @cancel="$emit('input', false)"
    >
        <loading-spinner class="loading-spinner" v-if="loading" />
        <b-form v-else @submit="save" :disabled="saving">
            <b-form-group
                id="client"
                :label="$t('client')"
                label-for="input-1"
                :invalid-feedback="errors.client_id"
                :state="getFieldState('client_id')"
            >
                <b-form-select
                    :state="getFieldState('client_id')"
                    required
                    v-model="client"
                    :disabled="this.clients.length === 1"
                >
                    <b-form-select-option :value="null"
                        >Please select an option</b-form-select-option
                    >
                    <b-form-select-option
                        v-for="c in clients"
                        :key="c.id"
                        :value="c.id"
                        >{{ c.name }}</b-form-select-option
                    >
                </b-form-select>
            </b-form-group>
            <b-form-group
                id="fieldset-1"
                :label="$t('collection_name')"
                label-for="input-1"
                :invalid-feedback="errors['name']"
                :state="getFieldState('name')"
            >
                <b-form-input
                    required
                    :state="getFieldState('name')"
                    v-model="name"
                    :placeholder="$t('collection_name_placeholder')"
                ></b-form-input>
            </b-form-group>
        </b-form>
        <div v-if="id && !loading" class="mt-3">
            <h5>{{ $t("attached_files") }}</h5>
            <file-manager
                v-if="id"
                title=""
                :resource-id="id"
                resource-type="collection"
            ></file-manager>
        </div>
    </b-modal>
</template>

<script>
import axios from "axios";
import FileManager from "../../Common/FileManager";
import LoadingSpinner from "../../Common/LoadingSpinner";

export default {
  name: "CollectionDialog",
  components: { FileManager, LoadingSpinner },
  props: {
    id: Number,
    value: Boolean
  },
  data() {
    return {
      clients: [],
      client: null,
      name: null,
      errors: {},
      saving: false,
      loading: false
    };
  },
  mounted() {},
  methods: {
    getFieldState(field) {
      return this.errors[field] === undefined ? null : false;
    },
    getClients() {
      axios.get("/api/clients").then(r => {
        this.clients = r.data.data;
        this.$store.commit("smartVaultSearch/setClients", r.data.data);

        if (this.clients.length === 1) {
          this.client = this.clients[0].id;
        }
      });
    },
    save(bvModalEvent) {
      bvModalEvent.preventDefault();
      this.saving = true;
      this.errors = {};
      let rp = this.id ? this.update() : this.create();
      rp.then(r => {
        this.$emit("input", false);
        this.$emit("saved", true);
      })
        .catch(err => {
          for (let [key, value] of Object.entries(err.response.data.errors)) {
            this.$set(this.errors, key, value[0]);
          }
        })
        .finally(() => {
          this.saving = false;
        });
    },
    create() {
      return axios.post("/api/collections", this.getData());
    },
    update() {
      return axios.put(`/api/collections/${this.id}`, this.getData());
    },
    getData() {
      return {
        name: this.name,
        client_id: this.client
      };
    },
    loadCollectionEditor() {
      this.errors = {};
      this.getClients();
      if (this.id) {
        this.loading = true;
        this.loadCollection();
      }
    },
    loadCollection() {
      axios.get(`/api/collections/${this.id}`).then(r => {
        let data = r.data.data;
        this.client = data.client.id;
        this.name = data.name;
        this.loading = false;
      });
    }
  }
};
</script>

<style scoped>
</style>
